import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface DeleteConfirmDialogProps {
  open: boolean;
  nombre: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
}

export function DeleteConfirmDialog({
  open,
  nombre,
  onConfirm,
  onCancel,
  loading,
}: DeleteConfirmDialogProps): JSX.Element {
  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel}>
      <DialogTitle>Eliminar establecimiento</DialogTitle>
      <DialogContent>
        <DialogContentText>
          ¿Estás seguro de que querés eliminar el establecimiento{' '}
          <strong>{nombre}</strong>? Esta acción no se puede deshacer.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" disabled={loading}>
          {loading ? 'Eliminando...' : 'Eliminar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
